const stripCharString = (InString, CharString) => {
	var OutString = "";
	for (var Count = 0; Count < InString.length; Count++) {
		var TempChar = InString.substring(Count, Count + 1);
		var Strip = false;
		for (var Countx = 0; Countx < CharString.length; Countx++) {
			var StripThis = CharString.substring(Countx, Countx + 1)
			if (TempChar == StripThis) {
				Strip = true;
				break;
			}
		}
		if (!Strip)
			OutString = OutString + TempChar;
	}
	return (OutString);
};

const get_full_year = (d) => {
	var y = "";
	if (d.getFullYear() != null) {
		y = d.getFullYear();
	} else {
		y = d.getYear();
		if (y > 69 && y < 100)
			y += 1900;
		if (y < 1000)
			y += 2000;
	}
	return y;
};

const allowInString = (InString, RefString) => {
	if (InString.length == 0)
		return (false);
	for (var Count = 0; Count < InString.length; Count++) {
		var TempChar = InString.substring(Count, Count + 1);
		if (RefString.indexOf(TempChar, 0) == -1)
			return (false);
	}
	return (true);
};

/**
 * adaptSisDateFormat
 * for userInput
 * @param inputText accepts also [+,-,*]
 * @returns {string} "YYYY/MM/DD" or null on error
 */
export const _adaptSisDateFormat = (inputText) => {
	inputText = stripCharString(inputText, " ");
	var in_date = "";
	if (inputText == "" || inputText == " ") {
		return null;
	}
	in_date = inputText.toUpperCase();
	var date_is_bad = 0;
	var ignore_rdi = 0;
	var has_rdi = 0;
	var today_used = 0;
	if (!allowInString(inputText, "/0123456789*+-")) {
		date_is_bad = 1;
	}
	var today_m = inputText.match(/\*/g);
	if (today_m) {
		if (today_m.length != 1)
			date_is_bad = 1;
		else
			today_used = 1;
	}
	var plusminus_m = inputText.match(/[+-]/g);
	if (!date_is_bad && plusminus_m) {
		if (plusminus_m.length > 1 || !today_used)
			date_is_bad = 1;
	}
	if (!date_is_bad) {
		if (in_date.indexOf("*") >= 0) {
			has_rdi = 1;
		}
		if (!date_is_bad && has_rdi && (in_date.indexOf("*") != 0)) {
			date_is_bad = 2;
		}
		if (!date_is_bad && has_rdi && (in_date.length == 1)) {
			var d = new Date();
			var return_month = parseInt(d.getMonth() + 1).toString();
			return_month = (return_month.length == 1 ? "0" : "") + return_month;
			var return_date = parseInt(d.getDate()).toString();
			return_date = (return_date.length == 1 ? "0" : "") + return_date;
			in_date = return_month + "/" + return_date + "/" + get_full_year(d);
			ignore_rdi = 1;
		}
		if (!ignore_rdi && !date_is_bad && has_rdi && (in_date.length > 1)
			&& !(in_date.charAt(1) == "+" || in_date.charAt(1) == "-")) {
			date_is_bad = 3;
		}
		if (!ignore_rdi && !date_is_bad && has_rdi
			&& isNaN(parseInt(in_date.substring(2, in_date.length), 10))) {
			date_is_bad = 4;
		}
		if (!ignore_rdi && !date_is_bad && has_rdi
			&& (parseInt(in_date.substring(2, in_date.length), 10) < 0)) {
			date_is_bad = 5;
		}
		if (!ignore_rdi && !date_is_bad && has_rdi) {
			var d = new Date();
			ms = d.getTime();
			var offset = parseInt(in_date.substring(2, in_date.length), 10);
			if (in_date.charAt(1) == "+") {
				ms += (86400000 * offset);
			} else {
				ms -= (86400000 * offset);
			}
			d.setTime(ms);
			var return_month = parseInt(d.getMonth() + 1).toString();
			return_month = (return_month.length == 1 ? "0" : "") + return_month;
			var return_date = parseInt(d.getDate()).toString();
			return_date = (return_date.length == 1 ? "0" : "") + return_date;
			in_date = return_month + "/" + return_date + "/" + get_full_year(d);
			ignore_rdi = 1;
		}
	}
	if (!date_is_bad) {
		var date_pieces = new Array();
		if (!has_rdi) {
			var d = new Date();
			var help_day = "";
			var help_month = "";
			var help_year = "";
			if (in_date.indexOf("/") == -1) {
				if (in_date.length < 3) {
					help_day = in_date;
				} else if (in_date.length < 5) {
					help_day = in_date.substr(in_date.length - 2);
					help_month = in_date.substring(0, in_date.length - 2);
				} else {
					help_day = in_date.substr(in_date.length - 2);
					help_month = in_date.substring(in_date.length - 4,
						in_date.length - 2);
					help_year = in_date.substring(0, in_date.length - 4);
				}
			} else {
				date_pieces = in_date.split("/");
				if (date_pieces.length == 1) {
					help_day = date_pieces[0];
				}
				if (date_pieces.length == 2) {
					var d = new Date();
					help_day = date_pieces[1];
					help_month = date_pieces[0];
				}
				if (date_pieces.length == 3) {
					var d = new Date();
					help_day = date_pieces[2];
					help_month = date_pieces[1];
					help_year = date_pieces[0];
				}
			}
			help_day = (help_day.length == 1 ? "0" : "") + help_day;
			help_month = (help_month.length == 1 ? "0" : "") + help_month;
			help_year = (help_year.length == 1 ? "0" : "") + help_year;
			if (help_year.length == 2) {
				if (parseInt(help_year) < 50)
					help_year = "20" + help_year;
				else
					help_year = "20" + help_year;
			}
			if (help_day == "")
				help_day = d.getDate().toString();
			if (help_month == "")
				help_month = parseInt(d.getMonth() + 1).toString();
			if (help_year == "")
				help_year = get_full_year(d);
			in_date = help_month + "/" + help_day + "/" + help_year;
		}
		date_pieces = in_date.split("/");
		if (date_pieces.length == 1) {
			var d = new Date();
			var return_month = parseInt(d.getMonth() + 1).toString();
			return_month = (return_month.length == 1 ? "0" : "") + return_month;
			in_date = return_month + "/" + in_date + "/" + get_full_year(d);
			date_pieces = in_date.split("/");
		}
		if (date_pieces.length == 2) {
			var d = new Date();
			in_date = get_full_year(d) + "/" + in_date;
			date_pieces = in_date.split("/");
		}
		if (date_pieces.length != 3 || parseInt(date_pieces[0], 10) < 1
			|| parseInt(date_pieces[0], 10) > 12
			|| parseInt(date_pieces[1], 10) < 1
			|| parseInt(date_pieces[1], 10) > 31
			|| (date_pieces[2].length != 2 && date_pieces[2].length != 4)) {
			date_is_bad = 6;
		}
	}
	if (date_is_bad) {
		return null;
	}
	var ms = Date.parse(in_date);
	var d = new Date();
	d.setTime(ms);
	var return_date = d.toLocaleString();
	var return_month = parseInt(d.getMonth() + 1).toString();
	return_month = (return_month.length == 1 ? "0" : "") + return_month;
	var return_date = parseInt(d.getDate()).toString();
	return_date = (return_date.length == 1 ? "0" : "") + return_date;
	return_date = get_full_year(d) + "/" + return_month + "/" + return_date;
	return return_date;
};

export const _adaptSisTimeFormat = (timeStr, withSec) => {
	if (withSec == undefined) {
		withSec = true;
	}
	//input :1 --> 00:01 => HH:mm
	if ((timeStr.length == 2) && (timeStr.indexOf(":") == 0)) {
		timeStr = "00:0" + timeStr.substring(1, timeStr.length);
	}
	//input :15 --> 00:15 => HH:mm
	if ((timeStr.length == 3) && (timeStr.indexOf(":") == 0)) {
		timeStr = "00" + timeStr;
	}
	//input 1:15 --> 01:15 => HH:mm
	if ((timeStr.length == 4) && (timeStr.indexOf(":") == 1)) {
		timeStr = "0" + timeStr;
	}
	//input 0:1
	//input 1:0 --> 01:0 => HH:mm
	if ((timeStr.length == 3) && (timeStr.indexOf(":") == 1)) {
		timeStr = "0" + timeStr;
	}
	// input 15:0 --> 15:00 => HH:mm
	if ((timeStr.length == 4) && (timeStr.indexOf(":") == 2)) {
		if (timeStr.charAt(timeStr.length - 1) == "0") {
			// input 15:0 --> 15:00 => HH:mm
			timeStr = timeStr + "0";
		} else {
			// input 15:1 --> 15:01 => HH:mm
			timeStr = timeStr.substring(0, timeStr.indexOf(":")) + ":0" + timeStr.substring(timeStr.indexOf(":") + 1, timeStr.length);
		}
	}
	// input 150:0 --> 150:00 => HHH:mm
	if ((timeStr.length == 5) && (timeStr.indexOf(":") == 3)) {
		timeStr = timeStr + "0";
	}


	// input 822 --> 0822 => HHmm
	if ((timeStr.length == 3) && (timeStr.indexOf(":") == -1)) {
		timeStr = "0" + timeStr;
	}
	// input 1 --> 0100 => HHmm
	if ((timeStr.length == 1) && (timeStr.indexOf(":") == -1)) {
		timeStr = "0" + timeStr + "00";
	}
	// input 15 --> 1500 => HHmm
	if ((timeStr.length == 2) && (timeStr.indexOf(":") == -1)) {
		timeStr = timeStr + "00";
	}


	if (withSec == true) {
		// input 1515 --> 151500  => HHmmss
		if ((timeStr.length == 4) && (timeStr.indexOf(":") == -1)) {
			timeStr = timeStr + "00";
		}
	}
	//	console.log("time "+time);
	return timeStr;
};